// import m1Air from "../images/macBookAirM1.png";
// import m2Air from "../images/macBookAir.png";
// import macPro from "../images/macBookPro.png";
// import ideaPad from "../images/ideaPad.png";
// import TUF from "../images/TUF.png";
// import Rog from "../images/Rog.png";
// import ZenBook from "../images/ZenBook.png";
// import LGGram from "../images/LGGram.png";
// import GalaxyBook from "../images/GalaxyBook.png";
// import Dell from "../images/Dell.png";
// import AEOR from "../images/AERO.png";

import ai from "../images/ai.png";
import back from "../images/back.png";
import bug from "../images/bug.png";
import embedded from "../images/embedded.png";
import front from "../images/front.png";
import mobile from "../images/mobile.png";
import security from "../images/security.png";
import swsolution from "../images/swsolution.png";

export const ResultData = [
  {
    id: 1,
    name: "프론트엔드 개발자",
    desc: "웹 어플리케이션 또는 모바일 앱의 사용자 인터페이스(UI)를 HTML, CSS 등을 사용하여 개발! 버튼, 입력 폼, 메뉴 등을 디자인하고  UI와 사용자 경험(UX)에 대한 이해도가 높아야 하며, 디자인, 기술적인 측면에서의 문제를 해결합니다!",
    best: "ISF",
    image: `${front}`,
  },
  {
    id: 2,
    name: "서버/백엔드 개발자",
    desc: "웹 어플리케이션 또는 모바일 앱의 서버 부분을 개발! 데이터베이스와 프로그래밍 언어를 사용하여 데이터 처리 및 비즈니스 로직을 구현해 서비스를 안정적으로 운영할 수 있도록 합니다!",
    best: "ESF",
    image: `${back}`,
  },
  {
    id: 3,
    name: "모바일 개발자",
    desc: "모바일 기기용 애플리케이션을 개발! 앱의 UI/UX 디자인, 사용자 인터페이스, 앱의 성능 최적화, 보안 등의 여러 측면에서 앱을 개발하고 유지보수하며 Android,iOS와 같은 모바일 운영체제와 관련된 개발 도구를 사용합니다! ",
    best: "ENF",
    image: `${mobile}`,
  },
  {
    id: 4,
    name: "SW/솔루션",
    desc: "기업이나 조직의 비즈니스 프로세스를 분석하고, 이를 지원하기 위한 소프트웨어를 개발하거나 구매하여 제공!",
    best: "INF",
    image: `${swsolution}`,
  },
  {
    id: 5,
    name: "인공지능/머신러닝",
    desc: "데이터를 분석하고, 이를 토대로 머신러닝 알고리즘을 개발하거나 적용하여 예측 모델을 개발! 머신러닝 알고리즘, 딥러닝, 자연어 처리 등의 인공지능 기술에 대한 이해와 다양한 프로그래밍 언어를 활용합니다!",
    best: "ENT",
    image: `${ai}`,
  },
  {
    id: 6,
    name: "QA 엔지니어",
    desc: "품질 보증(Quality Assurance) 역할을 담당하는 엔지니어! 소프트웨어 제품이나 서비스의 품질을 유지하고 개선하기 위해 다양한 테스트를 수행하며 다양한 테스트 기술과 툴을 이해하고 사용할 수 있는 능력이 필요!",
    best: "IST",
    image: `${bug}`,
  },
  {
    id: 7,
    name: "임베디드 개발자",
    desc: "마이크로컨트롤러나 마이크로프로세서와 같은 소형의 컴퓨터를 이용하여 작동하는 기기나 시스템을 개발! C와 같은 프로그래밍 언어와 함께 주로 어셈블리어를 사용! 임베디드 시스템은 제품의 안정성과 신뢰성이 중요하므로, 시스템의 안정성과 신뢰성을 높이기 위한 다양한 테스트와 디버깅 작업을 수행합니다!",
    best: "EST",
    image: `${embedded}`,
  },
  {
    id: 8,
    name: "보안 개발자",
    desc: "소프트웨어나 애플리케이션, 시스템 등의 보안을 담당하는 개발자! 취약점을 찾아 암호화 기술, 인증 기술 등 다양한 보안 기술을 사용하여 시스템의 보안성을 높이기 위해 노력합니다!",
    best: "INT",
    image: `${security}`,
  },
];
